import { emitter } from '@phoenix/event-bus';

export default class FindInBoutique {
  setReference(reference) {
    emitter.emit('set-reference', reference);
  }
}
